import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M68.6 17.4599L71.9001 12.3299L60.0101 1.8999H13.9401L2.05005 12.3299L5.35004 17.4599C5.35004 17.4599 2.54005 23.0399 5.68005 30.7999C8.33005 37.3499 8.98003 38.6299 8.16003 42.3199C7.45003 45.4899 4.53009 50.4499 4.53009 57.5499C4.53009 59.5799 6.00004 62.2199 7.17004 62.8299C8.33004 60.8499 10.1401 60.5999 10.1401 60.5999C10.1401 60.5999 10.1401 77.3599 23.1901 78.1799L51.4301 78.0099C66.4601 75.6999 64.3101 59.5099 64.3101 59.5099C64.3101 59.5099 65.6301 62.15 67.2801 65.95C71.5701 56.21 66.45 46.7899 65.79 42.2999C65.24 38.5599 65.7101 37.4499 68.7601 31.0699C72.0701 24.1899 68.6 17.4599 68.6 17.4599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M7.17006 62.83C7.17006 62.83 5.52007 56.06 9.81007 51.77C14.1001 47.48 14.3601 41.89 12.7801 38.06C10.4701 32.45 8.16008 26.01 11.1301 21.71"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M19.8802 25.1799C19.8802 25.1799 16.5801 31.7899 19.2201 39.5499C21.8601 47.3099 18.5602 53.42 17.4002 56.89C16.2402 60.36 14.1002 69.44 22.5202 74.89"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M66.97 62.83C66.97 62.83 68.62 56.06 64.33 51.77C60.04 47.48 59.78 41.89 61.36 38.06C63.67 32.45 65.98 26.01 63.01 21.71"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M54.2501 25.1799C54.2501 25.1799 57.5501 31.7899 54.9101 39.5499C52.2701 47.3099 55.5701 53.42 56.7301 56.89C57.8901 60.36 60.0301 69.44 51.6101 74.89"
        stroke={outline}
        strokeMiterlimit="10"
      />
    </g>
  )
}
